import React from "react";
import { Accordion, Box } from "@chakra-ui/react";
import { BlockHeader } from "../../../../../../../components/BlockHeader";
import { useTranslation } from "react-i18next";
import { MissingDataLabel } from "../../../../../components/MissingDataLabel";
import { QuestionAccordionItem } from "./QuestionsAndAnswers";

function ScopeTwoQuestions({ data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.suppliersData.aggregatedGeneralAndScope1And2Data.scopeTwo"
  });

  const mapBooleanAnswer = (answerString) => {
    return answerString === "true" ? t(`questions.booleanOptions.yes`) :
      answerString === "false" ? t(`questions.booleanOptions.no`) : answerString;
  };

  const mapQuestionAnswers = (attrKey) => {
    switch (attrKey) {
      case "locationBasedEmissionCalculated":
      case "marketBasedEmissionCalculated":
        return data[attrKey].map(obj => {
          return {
            ...obj,
            answer: mapBooleanAnswer(obj["answer"])
          };
        });
      default:
        return data[attrKey];
    }
  };

  return (
    <Box marginTop={10}>
      {/* We are checking for an answer in locationBasedEmissionCalculated array, because if an answer for a single
       field is saved then answers for all scope two fields are auto saved at that time as well.*/}
      <Box paddingBottom={data && data.locationBasedEmissionCalculated.length > 0 ? 6 : 0}>
        <BlockHeader
          title={t("title")}
          description={t("subTitle")}
        />
      </Box>
      {data && data.locationBasedEmissionCalculated.length > 0 ?
        <Accordion defaultIndex={[0]} allowToggle={true}>
          {Object.keys(data).map(attrKey => {
            const answersArr = mapQuestionAnswers(attrKey);
            return <QuestionAccordionItem
              key={`${attrKey}-question`}
              question={t(`questions.${attrKey}`)}
              answers={answersArr}
            />;
          })}
        </Accordion> :
        <MissingDataLabel />
      }
    </Box>
  );
}

export default ScopeTwoQuestions;